import { ChangeLogsDto } from '@core/services/dto/change-logs.dto';
import { formateUTCtoTZ } from '@shared/utils';
import * as moment from 'moment';

const DATE_REGEX = /(\b\d{1,2}[\/-]\d{1,2}[\/-]\d{4}(?:\s+\d{1,2}:\d{2}(?::\d{2})?(?:\s?[AP]M)?)?)/g;
const DATE_INPUT_FORMATS = [
    'DD/MM/YYYY hh:mm:ss',
    'DD/MM/YYYY HH:mm:ss',
    'DD-MM-YYYY hh:mm:ss',
    'DD-MM-YYYY HH:mm:ss',
    'DD/MM/YYYY hh:mm A',
    'DD/MM/YYYY HH:mm',
    'DD-MM-YYYY hh:mm A',
    'DD-MM-YYYY HH:mm',
    'DD/MM/YYYY',
    'DD-MM-YYYY'
];

export class ChangeLogsModel {
    id?: number;
    changeDate: string;
    changedBy: string;
    eventType: string;
    oldValue: string;
    newValue: string;

    constructor(dto: ChangeLogsDto) {
        this.id = dto.id;
        this.changeDate = dto.changeDate ? formateUTCtoTZ(dto.changeDate, 'DD-MM-YYYY HH:mm:ss') : dto.changeDate;
        this.changedBy = dto.changedBy;
        this.eventType = dto.eventType === 'Email' ? 'Email Sent' : dto.eventType;
        this.oldValue = normalizeDateStrings(dto.oldValue);
        this.newValue = normalizeDateStrings(dto.newValue);
    }
}

function normalizeDateStrings(value: string): string {
    if (!value) {
        return value;
    }

    return value.replace(DATE_REGEX, (match: string) => {
        const parsed = moment(match, DATE_INPUT_FORMATS, true);

        if (!parsed.isValid()) {
            return match;
        }

        return parsed.format('MM/DD/YYYY');
    });
}
